import GlobalCircumnavigateIcon from './GlobalCircumnavigateIcon'

export default GlobalCircumnavigateIcon
